import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { MiniApp } from '@torihada-inc/miniapps'
import getConfig from 'next/config'
import { snakeToCamelObjectInArray } from '@/utils/base'
import { useFanmeBackendGet } from '@/libs/fanme_backend'
import { PurchaseHistoryWithTip } from '@/types/Purchase'
import { getMiniAppInfo } from '@/pages/api/miniapp'
import { useAuth } from '@/contexts/AuthContext'
import Arrow_Right from '@/assets/img/icons/Arrow_Right.svg'
import { InfiniteScrollContainer } from '@/components/templates/InfiniteScroll'
import FanmeLogoGray from '@/assets/img/logo/LOGO_Gray.svg'
import ConfirmCvsInfo from '@/fanmeSdk/Payment/ConfirmCvsInfo'
import {
  StyledHistoryItem,
  StyledHistoryItemGrid,
  StyledItemImage,
  StyledItemName,
  StyledItemNonImage,
  StyledItemPrice,
  StyledItemPurchasedDate,
  StyledOrderNumber,
} from './index.style'

const limit = 10

interface Props {
  accountId: string
  purchaseItem: PurchaseHistoryWithTip | undefined
  setPurchaseItem: React.Dispatch<React.SetStateAction<PurchaseHistoryWithTip | undefined>>
  setVisiblePopup: React.Dispatch<React.SetStateAction<boolean>>
}
const BrowseMiniappPaymentHistory = ({
  accountId,
  purchaseItem,
  setPurchaseItem,
  setVisiblePopup,
}: Props) => {
  const { token } = useAuth()
  const { publicRuntimeConfig } = getConfig()
  const [miniApp, setMiniApp] = useState<MiniApp | undefined>()
  const [visibleCvsPop, setVisibleCvsPop] = useState(false)

  const [purchaseList, setPurchaseList] = useState<PurchaseHistoryWithTip[]>([])
  const [currentList, setCurrentList] = useState<PurchaseHistoryWithTip[]>([])

  const { data: historyData } = useFanmeBackendGet<PurchaseHistoryWithTip[]>(
    `${publicRuntimeConfig.PAYMENT_URL}/user/purchase_histories`,
  )

  const fetchMore = () => {
    const currentLength = currentList.length
    const newList = purchaseList.slice(0, currentLength + limit)
    setCurrentList(newList)
  }

  const initMiniApp = async () => {
    const res: any = await getMiniAppInfo(accountId)

    const miniAppData = new MiniApp(publicRuntimeConfig.PAYMENT_URL, res.user_uid, token as string)
    setMiniApp(miniAppData)
  }

  const toNext = (purchase: PurchaseHistoryWithTip) => {
    setPurchaseItem(purchase)
    if (purchase.isValid) {
      setVisiblePopup(true)
    } else {
      setVisibleCvsPop(true)
    }
  }

  useEffect(() => {
    if (!historyData) return
    const sortedHistory = snakeToCamelObjectInArray(historyData)
      .map(item => {
        if (item.purchasedAt) {
          item.purchasedAt = dayjs(item.purchasedAt).set('hour', dayjs(item.purchasedAt).hour() + 9)
        }
        return item
      })
      .sort((a: any, b: any) => (a.purchasedAt > b.purchasedAt ? -1 : 1))
    setPurchaseList(sortedHistory)
    setCurrentList(sortedHistory.slice(0, limit))
  }, [historyData])

  useEffect(() => {
    if (token) {
      initMiniApp()
    }
  }, [accountId, token])

  return (
    <>
      <InfiniteScrollContainer fetchMore={fetchMore}>
        {currentList.map((purchase, index) => {
          return (
            <StyledHistoryItem key={index} onClick={() => toNext(purchase)}>
              {purchase.tipId ? (
                <div className="w-[72px] h-[72px]" />
              ) : purchase.sellerAppItemIconUrl ? (
                <StyledItemImage
                  src={purchase.sellerAppItemIconUrl}
                  alt={purchase.sellerAppItemName}
                />
              ) : (
                <StyledItemNonImage>
                  <FanmeLogoGray
                    viewBox="-40 -20 300 300"
                    className="block mt-[10px] mx-0 mb-auto"
                  />
                </StyledItemNonImage>
              )}

              <StyledHistoryItemGrid>
                <StyledItemName>
                  {purchase.tipId ? 'チップ' : purchase.sellerAppItemName}
                </StyledItemName>
                <StyledItemPrice>¥{purchase.price?.toLocaleString()}</StyledItemPrice>

                <StyledItemPurchasedDate>
                  {purchase.isValid ? (
                    purchase.purchasedAt?.format('YYYY/MM/DD HH:mm')
                  ) : (
                    <span className="font-5 text-WHITE bg-RED px-1.5 pt-0.5 pb-1 rounded-full">
                      コンビニ決済未払い
                    </span>
                  )}
                </StyledItemPurchasedDate>
                {!purchase.tipId && (
                  <StyledOrderNumber>注文番号：{purchase.orderId || '-'}</StyledOrderNumber>
                )}
              </StyledHistoryItemGrid>
              <Arrow_Right className="w-4 h-4 my-auto mr-0 ml-auto" />
            </StyledHistoryItem>
          )
        })}
        {visibleCvsPop && (
          <ConfirmCvsInfo
            onClose={() => setVisibleCvsPop(false)}
            purchaserPurchasedItemId={purchaseItem?.id}
          />
        )}
      </InfiniteScrollContainer>
    </>
  )
}

export default BrowseMiniappPaymentHistory
